import { createContext, useState, useEffect } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [data, setData] = useState(null);

    useEffect(() => {

        const API_URL = `${process.env.REACT_APP_API}/impact/`;
        
        fetch(API_URL)
            .then(response => response.json()) 
            .then(data => {setData(data)})
            .catch(error => console.error('Fetch error:', error));
        
        // d3.json(INDIA_GEOJSON_URL)
        //     .then(data => setGeoData(data))
        //       .catch(error => console.error('GeoJSON fetch error:', error));

        // fetch("https://api.example.com/data")
        //     .then((res) => res.json())
        //     .then((result) => setData(result))
        //     .catch((error) => console.error("Error fetching data:", error));
    }, []);

    return (
        <DataContext.Provider value={{ data, setData }}>
            {children}
        </DataContext.Provider>
    );
};
